export const EMAIL_REG = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i // eslint-disable-line
export const NAME_REG = /^[a-z ']+$/i;
export const PHONE_REG = /^(\d{10})$/g; // Matches 1-10 digits or empty string
export const FORMATTED_PHONE_REG = /(\d{1,3})(\d{1,3})(\d{1,4})/g;
// Checks for valid template bindings, matches {{variable}}, {{some.variable}}, {{some.variable_someValue}}, etc.
export const VALID_TEMPLATE_BINDING_REG = /{{\s*[a-zA-Z_][\w]*(\.[a-zA-Z_][\w]*)*\s*}}/g;
// Checks for all template bindings, matches {{name}}, {{{name}}, {name}}, etc.
export const ALL_DYNAMIC_TEMPLATE_BINDINGS_REG = /{+[^{}]*}+/g;
// Check for valid human template bindings, matches [[Valid Token]]
export const VALID_HUMAN_TEMPLATE_BINDING_REG = /(?<!\[)\[\[\s*([^[\]\n\r]+?)\s*\]\](?!\])/g;
